export interface AnalyticsMetadata {
  [key: string]: string;
}

export function getAnalyticsMetadata() {
  const params = new URL(document.location.href).searchParams;
  const metadata: AnalyticsMetadata = {};
  params.forEach((value, key) => {
    metadata[key] = value;
  });
  return metadata;
}
